import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-m-account-created",
	templateUrl: "./account-created.component.html",
	styleUrls: ["./account-created.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class AccountCreatedComponent {
	@Input() set hasBonus(value: boolean) {
		this._hasBonus = coerceBooleanProperty(value);
	}
	get hasBonus() {
		return this._hasBonus;
	}

	@HostBinding("class.obg-m-account-created") cssHostClass = true;

	private _hasBonus = false;
}
